import { BgpUpdateRateSubscription } from "../../graphql/generated/operations";

/**
 * @param {BgpUpdateRateSubscription | undefined} data
 * @returns {number | undefined}
 */
export const formatter = (data) => data?.bgpUpdateRate[0]?.value;
